import { observer } from 'mobx-react';
import * as React from 'react';
import { Link } from '../../../Resource/Types';
import { T } from '../../../Translations';
import Display from './Display';
import LicensesFilter from './LicensesFilter';
import { ProductLicensesReactions } from './Reactions';
import { ProductLicensesStore } from './Store';

interface Props {
  productsLink: Link;
}

function ProductLicenses({ productsLink }: Props) {
  const store = React.useRef(new ProductLicensesStore()).current;

  React.useEffect(() => {
    store.loading(productsLink);
  }, [productsLink, store]);

  return (
    <>
      <div className="mt-7">
        <div className="mx-auto w-full max-w-clientPortalMaxWidth">
          <div className="mb-2 flex flex-col justify-between px-2.5 md:flex-row lg:px-12">
            <div className="flex w-full items-center justify-between p-2">
              <h2 className="items-center text-2xl font-semibold text-gray-900">
                <T kind="Product Licenses" />
              </h2>
              <LicensesFilter store={store} />
            </div>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-clientPortalMaxWidth px-2.5 lg:px-12">
        <div className="p-2 mt-5">
          <ProductLicensesReactions store={store} fireImmediately={true} />
          <Display store={store} />
        </div>
      </div>
    </>
  );
}

export default observer(ProductLicenses);
